import { Component, OnInit, Input, Output, EventEmitter , ChangeDetectorRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CityWebDataService } from 'src/app/services/city-web-data.service';
import { CurrentUserService } from 'src/app/services/current-user.service';
import { DataService } from 'src/app/services/data.service';
import { GmNoteService } from 'src/app/services/gm-note.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
    selector: 'app-deletemodel',
    templateUrl: './deletemodel.component.html',
    styleUrls: ['./deletemodel.component.scss'],
    standalone: false
})
export class CityEnterDeletemodelComponent implements OnInit {
  @Input() character_id: any;
  @Input() id: any;
  @Input() game_id: any;
  @Input() invitation_id: any;
  @Input() pagename: any;
  @Input() actionName: any;
  user_id: number | string;
  isNotDelete: boolean = false;

  isLoading: boolean = false;

  @Output() updateData: EventEmitter<any> = new EventEmitter();

  constructor(private dataserv: DataService,
    public activeModal: NgbActiveModal,
    private cityDataService: CityWebDataService,
    private currentUserService: CurrentUserService,
    private gmNoteService: GmNoteService,
    private toastService: ToastService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void { }

  passBack(value: string) {
    this.activeModal.close(value);
  }

  deleteCharacter() {
    this.isLoading = true;
    this.cdr.detectChanges();
    if (this.isNotDelete) {
      this.activeModal.close(true);
      this.isLoading = false;
      return;
    }
    if (this.actionName === 'accepchardetail') {
      this.dataserv
        .deleteappcharlist(this.character_id, this.game_id)
        .subscribe((res) => {
          if (res) {
            this.toastService.showSuccess(
              'Character deleted successfully!!!',
              'success'
            );
            this.isLoading = false;
            // Reload the list
            this.cdr.detectChanges();
            this.updateData.emit(res);
            this.closemodel();
          }
        });
    } else if (this.actionName === 'content') {
      this.dataserv.deleteContentById(this.id, this.user_id).subscribe((res) => {
        if (res) {
          this.toastService.showSuccess(
            'Content deleted.',
            'success'
          );
          this.isLoading = false;
          // Reload the list
          this.cdr.detectChanges();
            this.updateData.emit(res);
            this.closemodel();
        }
      });
    } else if (this.actionName === 'contentcity') {
      this.cityDataService.deleteCityContentById(this.id).subscribe((res) => {
        if (res) {
          this.toastService.showSuccess(
            'Content deleted.',
            'success'
          );
          this.isLoading = false;
        }
        this.cdr.detectChanges();
            this.updateData.emit(res);
            this.closemodel();
      });
    } else if (this.actionName === 'Game') {
      this.dataserv.deleteGame(this.game_id).subscribe(
        (res: any) => {
          if (res) {
            this.isLoading = false;
            this.toastService.showSuccess(
              'Game deleted successfully!!!',
              'success'
            );
            this.closemodel({
              isDelete: true,
              role: "game",
            });
            this.cdr.detectChanges();
          }
        },
        (error) => {
          this.isLoading = false;
          // Handle error if needed
          this.cdr.detectChanges();
          this.updateData.emit(null);
        }
      );
    } else if (this.actionName === 'Character') {
      this.dataserv
        .deleteCharacter(this.character_id, this.game_id)
        .subscribe(
          (res: any) => {
            if (res) {
              this.isLoading = false;
              this.toastService.showSuccess(
                'Character deleted successfully!!!',
                'success'
              );
              this.cdr.detectChanges();
            this.updateData.emit(res);
            this.closemodel();
            }
          },
          (error) => {
            this.isLoading = false;
            // Handle error if needed
            this.cdr.detectChanges();
          this.updateData.emit(null);
          }
        );
    } else if (this.actionName === 'map') {
      this.dataserv.deletemap(this.id, this.user_id).subscribe((res) => {
        if (res) {
          this.toastService.showSuccess(
            'Map deleted succussfully !!!',
            'success'
          );
          this.isLoading = false;
          this.closemodel({
            isDelete: true,
            role: "map",
          });
          this.cdr.detectChanges();
          // Reload the list
        }
      });
    } else if (this.actionName === 'Note') {
      this.gmNoteService.deleteNote(this.user_id, this.id).subscribe({
        next: (data: any) => {
          if (data.message) {
            this.toastService.showSuccess(
              'Note deleted successfully!!!',
              'success'
            );
            this.isLoading = false;
            // Reload the list
            this.cdr.detectChanges();
            this.updateData.emit(data.res);
            this.closemodel();
          }
        },
        error: (err) => {
          console.error('Error deleting note:', err);
        
          this.cdr.detectChanges();},
      });
    } else {
      // this.dataserv.delete_p_r_charlist(this.invitation_id).subscribe(
      //   (res) => {
      //     if (res) {
      //       this.toastService.showSuccess(
      //         'Character deleted successfully!!!',
      //         'success'
      //       );
      //       this.isLoading = false;
      //       // Reload the list
      //       this.updateData.emit(res);
      //       this.closemodel();
      //     }
      //   },
      //   (error) => {
      //     // Handle error if needed
      //     this.isLoading = false;
      //   }
      // );
    }
  }

  closemodel(data?) {
    this.activeModal.close({
      isDelete: data?.isDelete,
      role: data ? data.role : 'close',
    });
  }
}
